import { useEffect, useMemo } from 'react';
import { Outlet, useLocation, useParams } from 'react-router';
import {
  BackButton,
  Box,
  Center,
  FloatingContainer,
  Row,
  Screen,
  Stepper,
  Text,
} from '~/commonComponents';
import { CreateOnsiteInterviewSteps, TCreateOnsiteInterviewPageRoutes } from './Types';
import { useSafeLocationState } from './hooks';
import { useDispatch } from 'react-redux';
import { clearOnsiteInterviews } from '~/actions/PermanentJobs';

export const CreateOnsiteInterviewPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams<TCreateOnsiteInterviewPageRoutes>();
  const { isAfterJobPosting } = useSafeLocationState();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      if (id) {
        dispatch(clearOnsiteInterviews(id));
      }
    };
  }, [dispatch, id]);

  const currentStepIndex = useMemo(() => {
    if (location.pathname.endsWith(CreateOnsiteInterviewSteps.Reviews)) {
      return 1;
    }

    return 0;
  }, [location.pathname]);

  const targetBackUrl = useMemo(() => {
    if (isAfterJobPosting && currentStepIndex === 0) {
      return `/permanent-jobs/job-overview/${id}/job-details`;
    }
    return undefined;
  }, [currentStepIndex, id, isAfterJobPosting]);

  return (
    <Screen>
      <FloatingContainer borderRadius={4} paddingBlock={48} paddingInline={16}>
        <Row position="relative" alignItems="center" justifyContent="center">
          <Box position="absolute" left={0}>
            <BackButton url={targetBackUrl} />
          </Box>
          <Text bold fontSize={32} textAlign="center">
            Add Onsite Interviews
          </Text>
        </Row>
        <Center marginTop={24} width={420} marginBottom={40}>
          <Stepper
            currentStep={currentStepIndex}
            steps={['Onsite Interviews', 'Review and Confirm']}
          />
        </Center>
        <Outlet />
      </FloatingContainer>
    </Screen>
  );
};
